<header>
    <h1>{{ "benefit.header" | translate }}</h1>
</header>
<div class="content">
    <p>{{ "benefit.content" | translate }}</p>
</div>
